/** @format */

export type CartGhostDropTrigger = 'init' | 'navigation' | 'focus';

/**
 * Why the cart intent flag currently held in localStorage was set.
 * - `api_success`    — a cart/checkout API call returned 2xx while the cookie was present.
 * - `page_hydration` — the flag survived from a previous page load and the drop was seen at bootstrap.
 * - `storage_restore`— the flag survived from a previous page load and the drop was seen mid-session.
 * - `unknown`        — the flag was set without a declared source.
 */
export type CartIntentSource = 'api_success' | 'page_hydration' | 'storage_restore' | 'unknown';

export interface CartGhostDrop {
  userAgent: string;
  browserEngine: string;
  cookieCount: number;
  totalBytes: number;
  duplicateCarts: boolean;
  pageUrl: string;
  intentAge: number;
  intentAgeFormatted: string;
  detectionTrigger: CartGhostDropTrigger;
  visibilityState: DocumentVisibilityState;
  lastApiStatus: number | null;
  lastApiTraceId: string;
  intentSource: CartIntentSource;
}

export interface CartTelemetry {
  event: string;
  details: CartGhostDrop;
}

export type CartApiErrorReason = 'missing_cart_id' | 'expired' | 'malformed' | 'unknown';

export interface CartCookieContext {
  present: boolean;
  idHash: string;
  count: number;
  bytes: number;
  wellFormed: boolean;
}

export interface CartApiTelemetry {
  route: string;
  statusCode: number;
  context: CartCookieContext;
  errorReason?: CartApiErrorReason;
}

export interface CartPageLoadBaselinePayload {
  hydratedOk: boolean;
  pagePath: string;
}
